import { http } from "services/http";

export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function parseJwtExp(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000; // convert to ms
  } catch {
    return null;
  }
}

const REFRESH_BUFFER_MS = 299 * 1000; // call server when within 4m59s of JWT expiry
const HEARTBEAT_INTERVAL_MS = 15 * 60 * 1000; // call server at least every 15 min to keep session alive

export const OPRSessionManagement = {
  destroySession: function () {
    window.localStorage.removeItem("LogInEventExpiryDate");
    window.localStorage.removeItem("JwtTokenExpiry");
    window.localStorage.removeItem("LastHeartbeatTime");
  },
  hasLogInEventBeenSet: function () {
    return !!window.localStorage.getItem("LogInEventExpiryDate");
  },
  LogLoginEvent: async function (force = false) {
    // Decide whether to call the server BEFORE updating localStorage
    const storedExpiry = Number(
      window.localStorage.getItem("JwtTokenExpiry") || 0
    );
    const lastHeartbeat = Number(
      window.localStorage.getItem("LastHeartbeatTime") || 0
    );
    const timeUntilJwtExpiry = storedExpiry - Date.now();
    const timeSinceHeartbeat = Date.now() - lastHeartbeat;
    const shouldCallServer =
      force ||
      !storedExpiry ||
      timeUntilJwtExpiry <= REFRESH_BUFFER_MS ||
      timeSinceHeartbeat >= HEARTBEAT_INTERVAL_MS;

    // Always update client-side session expiry (unchanged behavior)
    const currentDate = new Date();
    if (window.location.hash.includes("forcedUpdate")) {
      currentDate.setHours(currentDate.getHours() + 1);
      currentDate.setMinutes(currentDate.getMinutes() - 50);
    } else {
      currentDate.setHours(currentDate.getHours() + 1);
      currentDate.setMinutes(currentDate.getMinutes() - 5);
    }
    window.localStorage.setItem("LogInEventExpiryDate", currentDate.getTime());

    if (shouldCallServer) {
      const response = await http.post("/api/session/getJwtToken");
      const jwtToken = response?.data?.jwt_token;
      if (jwtToken) {
        window.localStorage.setItem("LastHeartbeatTime", Date.now());
        const expMs = parseJwtExp(jwtToken);
        if (expMs) {
          window.localStorage.setItem("JwtTokenExpiry", expMs);
        }
      }
    }
  },

  isSession45Expired: function () {
    const expiredDate = new Date(
      Number(window.localStorage.getItem("LogInEventExpiryDate"))
    );
    const differenceInTime = expiredDate.getTime() - new Date().getTime();

    if (
      window.location.hash.includes("forcedUpdate") &&
      differenceInTime > 9000000
    ) {
      const currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + 1);
      currentDate.setMinutes(currentDate.getMinutes() - 50);
      window.localStorage.setItem(
        "LogInEventExpiryDate",
        currentDate.getTime()
      );
    }

    return differenceInTime < 0;
  },
};
